import "/home/runner/work/pocket-dimension-dice/pocket-dimension-dice/components/Rollable/components/RollContextMenu/styles.module_built.css";
const classes = {"adjustDiceTempSlot":"_9OLh5G_adjustDiceTempSlot","svg":"_9OLh5G_svg","dieIcon":"_9OLh5G_dieIcon","heading":"_9OLh5G_heading","adjustDiceButton":"_9OLh5G_adjustDiceButton","check":"_9OLh5G_check","adjustDiceTempText":"_9OLh5G_adjustDiceTempText","rotateIcon":"_9OLh5G_rotateIcon","list":"_9OLh5G_list","adjustmentColumn":"_9OLh5G_adjustmentColumn","adjustDiceHeader":"_9OLh5G_adjustDiceHeader","diceAdjustmentContainer":"_9OLh5G_diceAdjustmentContainer","disabled":"_9OLh5G_disabled","dmgRollOption":"_9OLh5G_dmgRollOption","listItemButton":"_9OLh5G_listItemButton","rollButton":"_9OLh5G_rollButton","diceNotation":"_9OLh5G_diceNotation","rollButtonText":"_9OLh5G_rollButtonText","section":"_9OLh5G_section","adjustDiceText":"_9OLh5G_adjustDiceText","menu":"_9OLh5G_menu","rollButtonTextSlot":"_9OLh5G_rollButtonTextSlot","toggleSwitchWrapper":"_9OLh5G_toggleSwitchWrapper","adjustDiceColumnText":"_9OLh5G_adjustDiceColumnText"}
export default classes

const _adjustDiceTempSlot0 = classes["adjustDiceTempSlot"]
export { _adjustDiceTempSlot0 as "adjustDiceTempSlot" }

const _svg0 = classes["svg"]
export { _svg0 as "svg" }

const _dieIcon0 = classes["dieIcon"]
export { _dieIcon0 as "dieIcon" }

const _heading0 = classes["heading"]
export { _heading0 as "heading" }

const _adjustDiceButton0 = classes["adjustDiceButton"]
export { _adjustDiceButton0 as "adjustDiceButton" }

const _check0 = classes["check"]
export { _check0 as "check" }

const _adjustDiceTempText0 = classes["adjustDiceTempText"]
export { _adjustDiceTempText0 as "adjustDiceTempText" }

const _rotateIcon0 = classes["rotateIcon"]
export { _rotateIcon0 as "rotateIcon" }

const _list0 = classes["list"]
export { _list0 as "list" }

const _adjustmentColumn0 = classes["adjustmentColumn"]
export { _adjustmentColumn0 as "adjustmentColumn" }

const _adjustDiceHeader0 = classes["adjustDiceHeader"]
export { _adjustDiceHeader0 as "adjustDiceHeader" }

const _diceAdjustmentContainer0 = classes["diceAdjustmentContainer"]
export { _diceAdjustmentContainer0 as "diceAdjustmentContainer" }

const _disabled0 = classes["disabled"]
export { _disabled0 as "disabled" }

const _dmgRollOption0 = classes["dmgRollOption"]
export { _dmgRollOption0 as "dmgRollOption" }

const _listItemButton0 = classes["listItemButton"]
export { _listItemButton0 as "listItemButton" }

const _rollButton0 = classes["rollButton"]
export { _rollButton0 as "rollButton" }

const _diceNotation0 = classes["diceNotation"]
export { _diceNotation0 as "diceNotation" }

const _rollButtonText0 = classes["rollButtonText"]
export { _rollButtonText0 as "rollButtonText" }

const _section0 = classes["section"]
export { _section0 as "section" }

const _adjustDiceText0 = classes["adjustDiceText"]
export { _adjustDiceText0 as "adjustDiceText" }

const _menu0 = classes["menu"]
export { _menu0 as "menu" }

const _rollButtonTextSlot0 = classes["rollButtonTextSlot"]
export { _rollButtonTextSlot0 as "rollButtonTextSlot" }

const _toggleSwitchWrapper0 = classes["toggleSwitchWrapper"]
export { _toggleSwitchWrapper0 as "toggleSwitchWrapper" }

const _adjustDiceColumnText0 = classes["adjustDiceColumnText"]
export { _adjustDiceColumnText0 as "adjustDiceColumnText" }
